var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRegisteredStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 26,
    height: 26,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(-74 -460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notepad-svgrepo-com_2_",
    "data-name": "notepad-svgrepo-com (2)",
    transform: "translate(74 460)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M18.75,24.083H6.833A4.333,4.333,0,0,1,2.5,19.75V7.833A4.333,4.333,0,0,1,6.833,3.5H18.75a4.333,4.333,0,0,1,4.333,4.333V19.75A4.333,4.333,0,0,1,18.75,24.083ZM6.833,5.667A2.167,2.167,0,0,0,4.667,7.833V19.75a2.167,2.167,0,0,0,2.167,2.167H18.75a2.167,2.167,0,0,0,2.167-2.167V7.833A2.167,2.167,0,0,0,18.75,5.667Z",
    transform: "translate(0.208 0.292)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M8.083,8A1.083,1.083,0,0,1,7,6.917V2.583a1.083,1.083,0,1,1,2.167,0V6.917A1.083,1.083,0,0,1,8.083,8Z",
    transform: "translate(0.583 0.125)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M12.083,8A1.083,1.083,0,0,1,11,6.917V2.583a1.083,1.083,0,0,1,2.167,0V6.917A1.083,1.083,0,0,1,12.083,8Z",
    transform: "translate(0.917 0.125)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M16.083,8A1.083,1.083,0,0,1,15,6.917V2.583a1.083,1.083,0,0,1,2.167,0V6.917A1.083,1.083,0,0,1,16.083,8Z",
    transform: "translate(1.25 0.125)",
    fill: "#136ad0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(82.327 470.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M15.174,5.9h1.482a1.756,1.756,0,0,1,.614-1.041h0a1.64,1.64,0,0,0,.93-.318c.04-.029.078-.061.116-.094a2.759,2.759,0,0,0,.755-2.04.454.454,0,0,0-.435-.47.437.437,0,0,0-.47.436,1.87,1.87,0,0,1-.5,1.433.7.7,0,0,1-.2.106l-.007,0a1.023,1.023,0,0,0-.65-.278H14.578a.833.833,0,0,0-.744.865A1.8,1.8,0,0,1,15.174,5.9Z",
    transform: "translate(-11.192 -1.519)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.075,
    cy: 1.053,
    rx: 1.075,
    ry: 1.053,
    transform: "translate(3.431)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M6.045,19.586c0-.817-.352-1.162-.84-1.162H4.072a1.268,1.268,0,1,0-.376,0H2.564a1.018,1.018,0,0,0-.886,1.064v1.654H6.045Z",
    transform: "translate(-1.678 -12.487)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M25.655,17.2a1.25,1.25,0,0,0,1.079,1.228H25.6a1,1,0,0,0-.863,1.064v1.654h4.333V19.589c0-.807-.339-1.147-.818-1.155-.007,0-.006-.007-.012-.007H27.109A1.244,1.244,0,1,0,25.655,17.2Z",
    transform: "translate(-19.726 -12.488)",
    fill: "#136ad0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRegisteredStudents);
export default __webpack_public_path__ + "static/media/total-registered-students.14d459f24c3b7f2793393bf19d5e57d1.svg";
export { ForwardRef as ReactComponent };